// 繁體中文表格（機器翻譯，未經人工審校 — ruling G4）。
// The Traditional Chinese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
import { boxDims, HW } from '../doc.js';
const S = {
  title: "分格收納盤",
  view: {
    "2d": "編輯格位",
    "3d": "3D 檢視",
  },
  gCell: "選取的格位",
  gSize: "分格盤尺寸",
  gWalls: "側壁",
  gStack: "堆疊",
  selName: (col, row, c) => `第 ${col + 1} 欄 · 第 ${row + 1} 格 —— ${c} 公厘`,
  colSize: "欄寬",
  cellSize: "格位深度",
  kinds: {
    auto: "自動",
    "1/2": "1/2",
    "1/3": "1/3",
    "2/3": "2/3",
    mm: "設定公厘",
  },
  split: "分割格位",
  addCol: "加一欄",
  del: "刪除格位",
  w: "寬度（公厘）",
  d: "深度（公厘）",
  bed: "列印床（公厘）",
  bedOption: (w, d) => `${w} × ${d}`,
  bedWarn: (w, d) => `托盤大於 ${w} × ${d} 公厘的列印床——可能無法一次列印成型`,
  wall: "壁厚",
  fillet: "圓角半徑",
  divider: "隔板高度",
  stackable: "可堆疊（上下邊緣互鎖）",
  clearance: "堆疊間隙",
  stackNote: (h) => `3 個堆疊：高 ${Math.round((3 * (h - 1) + 1) * 10) / 10} 公厘 · 再加一個托盤增高 ${Math.round((h - 1) * 10) / 10} 公厘`,
  size: (w, d, h) => `${w} × ${d} × ${h} 公厘`,
  gBox: "收納盒",
  boxOn: "加收納盒和蓋子",
  trayCount: "分格盤數量",
  partLabel: "已下載的零件",
  explode: "分解",
  parts: {
    tray: "分格盤",
    box: "收納盒",
    latch: "卡扣",
    lid: "蓋子",
  },
  boxNote: (wo, dd, hb, n) => `收納盒 ${wo} × ${dd} × ${hb} 公厘 · 可列印 ${n} 個托盤`,
  hwNote: (hinges) => `${HW.screw} 公厘螺母 × ${hinges} · 插銷 ${HW.pin} × ${HW.pinLen} 公厘 × 1（或 1.75 公厘線材）`,
  bedWarnPart: (part, w, d) => `${part} 列印尺寸為 ${w} × ${d} 公厘——大於列印床，可能無法一次列印成型`,
  tallWarn: (part, z) => `${part} 高 ${z} 公厘——超出大多數印表機的列印高度`,
  problem: {
    "auto-squeezed": "自動排格沒有剩餘空間——請調小您設定的格位尺寸",
    "too-small": "格位太小（至少需要壁厚的兩倍）",
    overflow: "您設定的尺寸加起來超出了托盤",
    "fractions-over": "比例加起來超過 1",
    "corner-clipped": "角落的格位被圓角裁掉——請減小圓角",
    "too-shallow": "托盤太淺——請加高或減小壁厚",
    "stack-wall": "側壁太薄，撐不住互鎖邊——請加厚側壁或減小間隙",
    "stack-shallow": "托盤太淺，無法堆疊——請加高",
    "box-narrow": (doc) => `收納盒太窄裝不下鉸鏈——托盤至少需要 ${Math.round(boxDims(doc).minW * 10) / 10} 公厘，或減小圓角`,
  },
  dlstl: "STL",
  copied: "已複製",
  fatal: "無法載入計算器——請嘗試重新整理頁面",
  unitMm: " 公厘",
  pct: (v) => `${v}%`,
  aboutP: "設計整理抽屜、桌面和工具箱的分格收納盤。尺寸格位自由設定，還能做可堆疊的邊沿，免費下載 3MF/STL。",
};
export default S;
